<div class="teamManagementContainer">
    @if (members().length === 0 && isLoaded()) {
      <p class="onlyTeamMember">You are currently the only member on this team.</p>
    }

    <div class="addTeamMemberWrapper">
      @if(!showAddTeamMemberForm()){
        <div class="addTeamMember_button">
          <button
            #addTeamMemberBtn
            type="button"
            class="addButton"
            (click)="toggleAddTeamMemberBtn()"
          >
            Team Members
          </button>
        </div>
      }

      @if (showAddTeamMemberForm()) {
        <app-add-team-member
          [(members)]="members"
          [groups]="groups()"
          (closed)="toggleAddTeamMemberBtn()"
          (saved)="toggleAddTeamMemberBtn()"
        ></app-add-team-member>
      }
  </div>

  @if (membersPending().length > 0) {
    <div class="pendingInviteWrapper">
      <p class="pendingInvite">You have {{ membersPending().length }} pending invitation{{ membersPending().length > 1 ? 's' : '' }}:</p>
      <ul class="teamManagementTeamMembersList pendingInvites">
        @for (member of membersPending(); track member){
          <li>
            <div class="pendingInviteMember">
              <div>{{ member.email }}</div>
              <div>
                @if (isResending(member.requestKey)) {
                  <span class="spinner" aria-hidden="true" style="display:inline-block;width:14px;height:14px;margin-right:6px;vertical-align:middle;">
                    <svg viewBox="0 0 50 50" style="width:14px;height:14px;">
                      <circle cx="25" cy="25" r="20" fill="none" stroke="#999" stroke-width="6" stroke-linecap="round" stroke-dasharray="31.4 188.4">
                        <animateTransform attributeName="transform" type="rotate" dur="1s" repeatCount="indefinite" from="0 25 25" to="360 25 25" />
                      </circle>
                    </svg>
                  </span>
                  <span>Sending…</span>
                } @else if (wasResendSuccessful(member.requestKey)) {
                  <span aria-live="polite">✓ Invite resent!</span>
                } @else {
                  <a (click)="resendInvite(member.requestKey)">Resend</a>
                }
              </div>
            </div>
            <div class="inviteSentDate">Sent {{ member.inviteDate | date: "EEE, MMM d" }}</div>
          </li>
        }
      </ul>
    </div>
  }

  @if(otherMembers().length > 0 || membersPending().length > 0) {
    <ul class="teamManagementTeamMembersList">
      @for (member of otherMembers(); track member) {
        <li class="inlineList">
          <mat-expansion-panel class="mat-elevation-z0 singleMemberExpansionPanel flush-panel">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="inlineList teamMemberDetails">
                  <app-user-avatar
                    [firstName]="member.firstName"
                    [lastName]="member.lastName"
                    [fullName]="member.name"
                    [avatar]="member.avatar"
                    [size]="'tiny'"
                    [isAdmin]="member.userRole == 2"
                  ></app-user-avatar>
                  <span class="labelNav teamMemberName" [matTooltip]="member.name">{{ member.name }}</span>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <app-edit-team-member
                [member]="member"
                [groups]="groups()"
                (onMemberRemoved)="removeMemberFromList($event)"
              >
              </app-edit-team-member>
            </ng-template>
          </mat-expansion-panel>

        </li>
      }
    </ul>
  }
</div>
